import { memo, useMemo } from 'react';

interface ProductPriceProps {
  amount: string;
  currencyCode: string;
  className?: string;
}

export const ProductPrice = memo(function ProductPrice({ amount, currencyCode, className = '' }: ProductPriceProps) {
  // Memoized formatted price
  const formatted = useMemo(() => {
    return new Intl.NumberFormat(getCurrencyLocale(currencyCode), {
      style: 'currency',
      currency: currencyCode,
    }).format(parseFloat(amount));
  }, [amount, currencyCode]);

  return <span className={className}>{formatted}</span>;
});

function getCurrencyLocale(currencyCode: string): string {
  const localeMap: Record<string, string> = {
    USD: 'en-US',
    ARS: 'es-AR',
    CLP: 'es-CL',
    UYU: 'es-UY',
    MXN: 'es-MX',
    BRL: 'pt-BR',
    EUR: 'es-ES',
  };
  return localeMap[currencyCode] || 'en-US';
}

